import { useState } from "react";
import CurrencyInputElement from "react-currency-input";
import classNames from "classnames/bind";

import styles from "../../styles/input.module.scss";

export const NumberInput = ({
  design = "one",
  placeholder = " ",
  onChange,
  onBlur,
  onFocus,
  autoFocus,
  label,
  value,
  floatLabel,
  className = "",
  invalid,
  suffix,
  defaultValue,
  onKeyUp,
  disabled,
  precision = 0,
  ...props
}) => {
  const cx = classNames.bind(styles);

  const { name } = props;
  const id = props.id || name;

  const currencyConfig = {
    precision: precision,
    prefix: "",
    decimalSeparator: ",",
    thousandSeparator: ".",
  };

  return (
    <div className={`${styles.inputContainer} ${className}`}>
      <div className={styles.input}>
        {label && (
          <label className={styles.label} htmlFor={name}>
            {label}
          </label>
        )}
        <CurrencyInputElement
          id={id}
          type={"tel"}
          decimalSeparator={currencyConfig.decimalSeparator}
          thousandSeparator={currencyConfig.thousandSeparator}
          precision={currencyConfig.precision}
          prefix={currencyConfig.prefix}
          name={name}
          value={value}
          placeholder={placeholder}
          onChangeEvent={onChange}
          onBlur={onBlur}
          onFocus={onFocus}
          autoComplete="off"
          autoFocus={autoFocus}
          defaultValue={defaultValue}
          onKeyUp={onKeyUp}
          suffix={suffix}
          disabled={disabled}
          className={cx({
            invalid: invalid,
            [`design-${design}`]: true,
          })}
        />
        {floatLabel && (
          <label
            className={cx({
              float: true,
              invalid: invalid,
            })}
          >
            {floatLabel}
          </label>
        )}
      </div>

      {invalid && <span className={styles.error} />}
    </div>
  );
};
